import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { getMeasurementLiveness, LivenessState } from '@cosmos/shared';

@Component({
  selector: 'cosmos-measurement-liveness-badge',
  templateUrl: './measurement-liveness-badge.component.html',
  imports: [TranslatePipe, TagModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeasurementLivenessBadgeComponent {
  readonly measurementType = input.required<string>();
  readonly lastTimestamp = input<Date | null>(null);

  readonly liveness = computed<LivenessState>(() =>
    getMeasurementLiveness(this.measurementType(), this.lastTimestamp())
  );

  readonly severity = computed(() => {
    switch (this.liveness()) {
      case 'green': return 'success';
      case 'amber': return 'warn';
      case 'red': return 'danger';
      default: return 'secondary';
    }
  });
}
